import { all } from "redux-saga/effects";
import { saga as currentUserWatcher } from "../modules/CurrentUser";
import { saga as cycleFormWatcher } from "../modules/Dashboard/Cycles/CreateCycle";
import { saga as cycleParticipantsWatcher } from "../modules/Dashboard/Cycles/CycleParticipants";
import { saga as myEmployeesWatched } from "../modules/Dashboard/MyEmployees";
import { saga as feedbackWatcher } from "../modules/Dashboard/MyFeedbacks";
import { saga as myPeersWatcher } from "../modules/Dashboard/MyPeers";
import { saga as myPeerQuestionnaireWatcher } from "../modules/MyPeerQuestionnaire";
import { saga as myQuestionnaireWatcher } from "../modules/MyQuestionnaire";
import { saga as talkSheetWatcher } from "../modules/TalkSheet";
import { filterReferencesWatcher, additionalCommentsLimitWatcher } from "./sagas";
export default function* () {
  yield all([
    additionalCommentsLimitWatcher(),
    currentUserWatcher(),
    cycleFormWatcher(),
    cycleParticipantsWatcher(),
    feedbackWatcher(),
    filterReferencesWatcher(),
    myEmployeesWatched(),
    myPeerQuestionnaireWatcher(),
    myPeersWatcher(),
    myQuestionnaireWatcher(),
    talkSheetWatcher()
  ]);
}
